import TokenContext from './TokenContext';
import { useContext } from 'react';

export default () => useContext(TokenContext);
